export default "__VITE_ASSET__96c43f9f__"